const TrustSection = () => {
  const features = [
    {
      icon: 'ri-search-line',
      title: 'Research-Driven',
      description: 'Every recommendation backed by thorough analysis and testing',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Transparent Reviews',
      description: 'Honest insights with clear affiliate disclosure',
    },
    {
      icon: 'ri-refresh-line',
      title: 'Always Updated',
      description: 'Content regularly reviewed to ensure accuracy',
    },
  ];

  return (
    <section className="py-20 lg:py-24 bg-gradient-to-br from-amber-50 via-orange-50 to-gray-50">
      <div className="max-w-6xl mx-auto px-6 lg:px-12 text-center">
        <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-6 font-inter">
          Why Trust Simsers Affiliate
        </h2>

        <div className="flex items-center justify-center gap-3 mb-4">
          <div className="flex -space-x-3">
            <div className="w-16 h-16 rounded-full bg-gradient-to-br from-orange-400 to-orange-600 border-4 border-white shadow-lg"></div>
            <div className="w-16 h-16 rounded-full bg-gradient-to-br from-teal-400 to-teal-600 border-4 border-white shadow-lg"></div>
            <div className="w-16 h-16 rounded-full bg-gradient-to-br from-amber-400 to-amber-600 border-4 border-white shadow-lg"></div>
            <div className="w-16 h-16 rounded-full bg-gradient-to-br from-gray-400 to-gray-600 border-4 border-white shadow-lg"></div>
          </div>
        </div>

        <p className="text-lg text-gray-700 font-medium mb-16 max-w-2xl mx-auto">
          Built by researchers and enthusiasts across 23 specialized fields
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
          {features.map((feature, index) => (
            <div key={index} className="text-center">
              <div className="w-14 h-14 flex items-center justify-center bg-orange-100 rounded-2xl mx-auto mb-5">
                <i className={`${feature.icon} text-3xl text-orange-600`}></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3 whitespace-nowrap">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustSection;
